import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/reportes/DetallesBodegas';

import DetalleBajaBodega from './DetalleBajaBodega';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.detalles_reporte_bodega,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(DetalleBajaBodega);
